module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('a', {
    staticClass: "x-mt-tiny xtotop",
    class: {
      xactive: _vm.visible
    },
    on: {
      "click": _vm.toTopHandler
    }
  }, [_c('i', {
    staticClass: "twui-ico xtotop"
  }), _c('span', [_vm._v("返回顶部")])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/_vue-loader@12.2.2@vue-loader/lib/template-compiler?{"id":"data-v-ec23178c","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/_vue-loader@12.2.2@vue-loader/lib/selector.js?type=template&index=0!./src/components/tw-totop.vue
// module id = 601
// module chunks = 1